import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "totals" }
const _hoisted_2 = { class: "totals__values" }
const _hoisted_3 = { class: "totals__item" }
const _hoisted_4 = { class: "totals__label" }
const _hoisted_5 = { class: "totals__value" }
const _hoisted_6 = { class: "totals__item" }
const _hoisted_7 = { class: "totals__label" }
const _hoisted_8 = { class: "totals__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCurrencyAmount = _resolveComponent("BaseCurrencyAmount")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('claims.new.footer.total-volume')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.totals.volume) + " " + _toDisplayString(_ctx.$t('claims.kg')), 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('claims.new.footer.total-claim-amount')), 1),
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_BaseCurrencyAmount, {
            currency: _ctx.agreement.currency,
            amount: _ctx.totals.billbackAmount
          }, null, 8, ["currency", "amount"])
        ])
      ])
    ])
  ]))
}